export default "__VITE_ASSET__HkHyOgNd__"